module.exports = __webpack_public_path__ + "static/media/Dunstan.8ca89623.md";